module.exports = __webpack_public_path__ + "img/galp.d3e1cd28.png";